import { emptyCheck } from './emptyCheck.js';
export const shell = {
    DisallowSigned: emptyCheck
};
